import React, { useEffect, useState } from "react";
import "./FOTopGainerLooser.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function FOTopGainerLooser() {
    // WebSocket connection
    const { foTopGainerLooserData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );
    const [foTopGainerData, setFoTopGainerData] = useState([]);
    const [foTopLooserData, setFoTopLooserData] = useState([]);

    /* ============================================== */

    useEffect(() => {
        if (foTopGainerLooserData) {
            setFoTopGainerData(foTopGainerLooserData?.FO_TOP_GAINERS?.data || []);
            setFoTopLooserData(foTopGainerLooserData?.FO_TOP_LOOSERS?.data || []);
            console.log("foTopGainerData => ", foTopGainerData);
            console.log("foTopLooserData => ", foTopLooserData);
        }
    }, [foTopGainerLooserData]);
    /* ================= HELPERS ================= */

    const formatPercentage = (value) => {
        if (value == null || isNaN(value)) return "--";

        return Number(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };
  
    return (
        <div className="fo-top-gainer-looser">
            <div className="table-container">
                <div className="top-gainer-looser-header">
                    <h2 className="top-gainer-looser-heading">
                        <span className="top-gainer-looser-span">F&O TOP GAINERS</span>
                    </h2>
                </div>
                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">

                    <thead>
                        <tr>
                            <th>SYMBOL</th>

                            <th>OPEN</th>
                            <th>HIGH</th>
                            <th>LOW</th>
                            <th>PREV CLOSE</th>
                            <th>LTP</th>
                            <th>CHNG(%)</th>
                            <th>VOLUME(shares)</th>
                            <th>VOLUME(lakh)</th>
                        </tr>
                    </thead>

                    <tbody>
                        {foTopGainerData?.length > 0 ? (
                            foTopGainerData.map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.symbol ?? "--"}</td>
                                     <td>{formatPercentage(row.open_price ?? "--")}</td>
                                    <td>{formatPercentage(row.high_price ?? "--")}</td>
                                    <td>{formatPercentage(row.low_price ?? "--")}</td>
                                    <td>{formatPercentage(row.prev_price ?? "--")}</td>
                                    <td>{formatPercentage(row.ltp ?? "--")}</td>
                                    <td className={`${row.perChange == null ? ""
                                        : Number(row.perChange) >= 0
                                            ? "positive" : "negative"}`}  >
                                        {row.perChange != null ? `${Number(row.perChange) >= 0 ? "+" : ""}
                                        ${Number(row.perChange).toFixed(2)}%` : "--"}
                                    </td>
                                    <td>{formatPercentage(row.trade_quantity ?? "--")}</td>
                                    <td>{formatPercentage(row.turnover ?? "--")}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="15">Waiting for live data...</td>
                            </tr>
                        )}
                    </tbody>


                </table>
                <div className="top-gainer-looser-header">
                    <h2 className="top-gainer-looser-heading">
                        <span className="top-gainer-looser-span">F&O TOP LOOSERS</span>
                    </h2>
                </div>
                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">
                    <thead>
                        <tr>
                            <th>SYMBOL</th>

                            <th>OPEN</th>
                            <th>HIGH</th>
                            <th>LOW</th>
                            <th>PREV CLOSE</th>
                            <th>LTP</th>
                            <th>CHNG(%)</th>
                            <th>VOLUME(shares)</th>
                            <th>VOLUME(lakh)</th>
                        </tr>
                    </thead>

                    <tbody>
                        {foTopLooserData?.length > 0 ? (
                            foTopLooserData.map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.symbol ?? "--"}</td>
                                    <td>{formatPercentage(row.open_price ?? "--")}</td>
                                    <td>{formatPercentage(row.high_price ?? "--")}</td>
                                    <td>{formatPercentage(row.low_price ?? "--")}</td>
                                    <td>{formatPercentage(row.prev_price ?? "--")}</td>
                                    <td>{formatPercentage(row.ltp ?? "--")}</td>
                                    <td
                                        className={`${row.perChange == null ? "" : Number(row.perChange) >= 0
                                            ? "positive" : "negative"}`} >
                                        {row.perChange != null
                                            ? `${Number(row.perChange) >= 0 ? "+" : ""}
                                            ${Number(row.perChange).toFixed(2)}%` : "--"}
                                    </td>
                                    <td>{formatPercentage(row.trade_quantity ?? "--")}</td>
                                    <td>{formatPercentage(row.turnover ?? "--")}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="15">Waiting for live data...</td>
                            </tr>
                        )}
                    </tbody>

                    <tfoot className="fixed-footer">
                        <tr className="footer-left">
                            <td colSpan="15">noptionwave © 2026</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
}
